import React, { useState } from "react";
import "../css/header.css";
import { Link } from "react-router";

const Header = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const HeaderBar = ({ path, label }) => (
    <li>
      <Link className={window.location.pathname === path ? "selected" : ""} to={path}>
        {label}
      </Link>
    </li>
  );
  return (
    <>
    <div className="container fixed">
      <header className="header">
        <div className="header-container">
          <div className="logo">
            <Link to="/">
              <img
                src="/assets/logoheader.png"
                alt="Continental Lease Advisors Logo"
              />
            </Link>
          </div>
          <nav id="main-nav" className={`nav ${isMobileMenuOpen ? "mobile-menu-open" : ""}`}>
            <ul>
            <HeaderBar path="/" label="Home" />
            <HeaderBar path="/about" label="About" />
            <HeaderBar path="/services" label="Services" />
            <HeaderBar path="/leadership" label="Leadership" />
            <HeaderBar path="/questions" label="Questions" />
            <HeaderBar path="/contact" label="Contact" />


              <li>
                <a
                  href="https://www.linkedin.com/company/continental-lease-advisors/"
                  rel="noopener noreferrer"
                  target="_blank"
                  className="linkedin-icon"
                  aria-label="Continental Lease Advisors on LinkedIn (opens in new tab)"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    data-supported-dps="24x24"
                    fill="currentColor"
                    className="mercado-match"
                    width="24"
                    height="24"
                    focusable="false"
                    aria-hidden="true"
                  >
                    <path d="M20.5 2h-17A1.5 1.5 0 002 3.5v17A1.5 1.5 0 003.5 22h17a1.5 1.5 0 001.5-1.5v-17A1.5 1.5 0 0020.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 118.3 6.5a1.78 1.78 0 01-1.8 1.75zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0013 14.19a.66.66 0 000 .14V19h-3v-9h2.9v1.3a3.11 3.11 0 012.7-1.4c1.55 0 3.36.86 3.36 3.66z"></path>
                  </svg>
                </a>
              </li>
            </ul>
          </nav>

          <button
            className="mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
            aria-label={isMobileMenuOpen ? "Close navigation menu" : "Open navigation menu"}
            aria-expanded={isMobileMenuOpen}
            aria-controls="main-nav"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </header>
    </div>
    <div id="main-content" tabIndex="-1" style={{ outline: "none" }} />
    </>
  );
};

export default Header;
